import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { translate as t } from "../../../../translate/localization";
import CobeeTextField from "../../../../../app/components/CobeeTextField";
import useStyles from "../../styles";

export default function RowPrivateUse({
  privateUsePercentage,
  setPrivateUsePercentage,
}) {
  const { secondColumn, fieldRowSpacing, inputLabel } = useStyles();
  return (
    <>
      <Grid item xs={6} container alignItems="center">
        <Typography variant="body2">
          {t("common-messages.private-use")}:
        </Typography>
        <Typography variant="body2">
          {t("common-messages.private-use-message")}
        </Typography>
      </Grid>
      <Grid
        item
        xs={6}
        container
        alignItems="center"
        className={`${secondColumn} ${fieldRowSpacing}`}
      >
        <Grid item xs={4}>
          <CobeeTextField
            type="number"
            min={0}
            max={100}
            minWidth="100%"
            value={privateUsePercentage}
            onChange={(e) => setPrivateUsePercentage(e.target.value)}
          />
        </Grid>
        <Grid item xs={8}>
          <Typography variant="body2" className={inputLabel}>
            %
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

RowPrivateUse.propTypes = {
  privateUsePercentage: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  setPrivateUsePercentage: PropTypes.func,
};

RowPrivateUse.defaultProps = {
  privateUsePercentage: "0",
  setPrivateUsePercentage: () => {},
};
